import React, { createContext, useState, useCallback, useContext } from 'react';

const NotificationContext = createContext(null);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

// Helper to format currency - place in utils if you have one, or here for now
const formatCurrencyForNotification = (value) => {
  const val = parseFloat(value);
  if (isNaN(val)) return '$0.00'; // Default for NaN
  return `$${val.toFixed(2)}`;
};


const NotificationBanner = ({ notification, onClose }) => {
  if (!notification) return null;

  const { message, type, details } = notification;
  let bannerClass = 'notification-banner';
  let detailsContent = null;

  switch (type) {
    case 'success':
      bannerClass += ' success';
      break;
    case 'error':
      bannerClass += ' error';
      break;
    case 'info':
    default:
      bannerClass += ' info';
      break;
  }

  if (details && details.profitLoss !== undefined) {
    const profitLossNum = parseFloat(details.profitLoss);
    const isProfit = profitLossNum >= 0;
    detailsContent = (
      <span className={`profit-loss ${isProfit ? 'positive-text' : 'negative-text'}`}>
         P/L: {isProfit ? '+' : ''}{formatCurrencyForNotification(profitLossNum)}
      </span>
    );
  }


  return (
    <div className={bannerClass}>
      <span className="notification-message">{message}</span>
      {detailsContent && <span className="notification-details">{detailsContent}</span>}
      <button onClick={onClose} className="notification-close-btn">&times;</button>
    </div>
  );
};


export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null); // { message: string, type: 'success' | 'error' | 'info', details?: any }

  const addNotification = useCallback((message, type, details = null, duration = 7000) => {
    console.log('[NotificationContext] addNotification called:', { message, type, details });
    setNotification({ message, type, details });
    const timerId = setTimeout(() => {
      setNotification(null);
    }, duration);
    // Optional: store timerId if you want to allow programmatic clearing before timeout
  }, []);

  const clearNotification = useCallback(() => {
    console.log('[NotificationContext] clearNotification called');
    setNotification(null);
  }, []);

  return (
    <NotificationContext.Provider value={{ addNotification, clearNotification }}>
      {children}
      {notification && console.log('[NotificationContext] Rendering NotificationBanner with:', notification)}
      {notification && <NotificationBanner notification={notification} onClose={clearNotification} />}
    </NotificationContext.Provider>
  );
}; 